import { TransitionGroup } from 'react-transition-group';
import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { AnimationWrapper } from '@components/skeleton-loaders/AnimationWrapper';

export const Container = styled.div`
  width: 100%;
  padding: ${spacing.space32} 0 ${spacing.space32} 0;

  @media (max-width: ${breakpoints.m}) {
    padding: ${spacing.space64} 0 ${spacing.space64} 0;
  }
`;

export const Title = styled.h2`
  margin-bottom: ${spacing.space24};
`;

export const AnimationGrid = styled(TransitionGroup)`
  grid-column: 1 / -1;
`;

export const StyledAnimationWrapper = styled(AnimationWrapper)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${spacing.space24};

  @media (max-width: ${breakpoints.l}) {
    gap: ${spacing.space32} ${spacing.space24};
  }

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
`;
